import { render, staticRenderFns } from "./add_discount.vue?vue&type=template&id=1f74e4f4&scoped=true"
import script from "./add_discount.vue?vue&type=script&lang=js"
export * from "./add_discount.vue?vue&type=script&lang=js"
import style0 from "./add_discount.vue?vue&type=style&index=0&id=1f74e4f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f74e4f4",
  null
  
)

export default component.exports